<template>
  <div class="assest-page ">
    <div class="statistics-box">
      <div class="flex-center-start label">
        <span>{{i18n.t('assest.label1')}}({{bitName}})</span>
        <img :src="showMoney ? eyeUrl2 : eyeUrl" alt="" @click="changeMoneyType">
      </div>

      <div class="flex-end-start money-info" >
        <div class="total flex-end-start">{{moneyStr}}</div>
        <div class="desc flex-end-start">
          <span>
            ≈ {{showMoney ? convertedAssetMoney : '****'}}
            <span v-if="showMoney" class="asset-unit-text" @click.stop="openValuationPopup">{{valuationCurrency}}</span>
          </span>
          <span class="asset-change-badge" :class="showMoney ? asset24hRateClass(Asset24hChangeRate) : ''">
            {{showMoney ? formatAsset24hRate(Asset24hChangeRate) : '****'}}
          </span>
        </div>
      </div>

      <div class="flex today-static">
        <div class="flex-1 flex-column-start-center">
          <div class="name">{{i18n.t('assest.label8')}}({{bitName}})</div>
          <div class="count">{{ showMoney ? use : '****'}}</div>
        </div>
        <div class="flex-1 flex-column-start-center">
          <div class="name">{{i18n.t('assest.label9')}}({{bitName}})</div>
          <div class="count" :class="showMoney ? (ProfitAndLoss > 0 ? 'green' : 'red') : ''">{{showMoney ? ProfitAndLoss : '****'}}</div>
        </div>
      </div>
    </div>

    <div class="tab-list flex-center-start">
      <div class="tab flex-column-center" @click="toPath('recharge')">
        <img :src="rechargeUrl" alt="">
        <span>{{i18n.t('assest.label2')}}</span>
      </div>
      <div class="tab flex-column-center" @click="toWithdraw">
        <img :src="withdrawUrl" alt="">
        <span>{{i18n.t('assest.label3')}}</span>
      </div>
      <div class="tab flex-column-center" @click="toPath('transfer', {type: 1})">
        <img :src="transferUrl" alt="">
        <span>{{i18n.t('assest.label4')}}</span>
      </div>
      <div class="tab flex-column-center" @click="toPath('exchange')">
        <img :src="exchangeUrl" alt="">
        <span>{{i18n.t('assest.label10')}}</span>
      </div>
      <div class="tab flex-column-center" @click="toPath('assestLog', {type: 5})">
        <img :src="debtUrl" alt="">
        <span>{{i18n.t('assest.label5')}}</span>
      </div>
    </div>

    <div class="sub-title">{{i18n.t('assest.label6')}}</div>

    <div class="menu-list">
      <div class="menu flex-center-between" v-for="(item, i) in accountList" :key="i" @click="toAccount(item, i)">
        <div class="flex-center">
          <div class="icon-wrapper">
            <img :src="item.url" alt="">
          </div>
          <div class="content-wrapper">
            <div class="label">{{item.name}}</div>
            <div class="count">
              <span class="big">{{showMoney ? item.count : '****'}}</span>
              <span>
                ≈ {{showMoney ? getBitMoney(item.count) : '****'}}
                <span v-if="showMoney" class="asset-unit-text" @click.stop="openValuationPopup">{{valuationCurrency}}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Popup v-model="showValuationPopup" position="bottom" round class="asset-unit-popup">
      <div class="asset-unit-popup-title">{{i18n.t('bit.title')}}</div>
      <div class="asset-unit-popup-list">
        <div
          class="asset-unit-popup-item flex-center-between"
          v-for="item in valuationOptions"
          :key="item"
          :class="{ active: valuationCurrency == item }"
          @click="chooseValuationCurrency(item)">
          <span>{{item}}</span>
          <Icon color="#f7A600" name="success" v-if="valuationCurrency == item"></Icon>
        </div>
      </div>
    </Popup>


 
  </div>
</template>
<script>
import { Popup, Button, Icon } from 'vant'
import { checkAuth } from '@/api/setting'
import { allTrades, myAssets } from '@/api/assest'
import { userInfo } from '@/api/user'
import { setAssets } from '@/utils/auth'
import { getCoinList } from '@/api/index'
import { formatAsset24hRate, asset24hRateClass } from '@/utils/assetChange'
import {
  ASSET_VALUATION_CURRENCIES,
  buildAssetValuationPriceMap,
  getAssetValuationDisplay
} from '@/utils/assetValuation'
export default {
  components: {
    Popup,
    Button,
    Icon
  },
  data() {
    const storedValuationCurrency = localStorage.getItem('assetValuationCurrency')
    return {
      eyeUrl: require('../../assets/imgs/icon-eye.png'),
      eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
      rechargeUrl: require('../../assets/imgs/icon-recharge.png'),
      withdrawUrl: require('../../assets/imgs/icon-withdraw.png'),
      transferUrl: require('../../assets/imgs/icon-transfer.png'),
      debtUrl: require('../../assets/imgs/icon-debt.png'),
      exchangeUrl: require('../../assets/imgs/icon-transfer.png'),
      showMoney: true,
      userMoney: '0.00',
      bitName: 'USDT',
      bitId: '1',
      showBitPage: false,
      showRecharge: false,
      showModal: false,
      rechargeIndex: -1,
      authIndex: 1,
      rechargeName: '',
      ProfitAndLoss: 0,
      Asset24hChangeRate: '0.00',
      use: 0,
      assetsData: {},
      realNameStatus: '',
      valuationOptions: ASSET_VALUATION_CURRENCIES,
      valuationCurrency: ASSET_VALUATION_CURRENCIES.indexOf(storedValuationCurrency) > -1 ? storedValuationCurrency : 'BTC',
      valuationPriceMap: {},
      showValuationPopup: false,
    }
  },
  computed: {
    moneyStr() {
      return this.showMoney ? this.userMoney : '****'
    },
    convertedAssetMoney() {
      return this.getBitMoney(this.userMoney)
    },
    accountList() {
      return [
				{
          url: require('../../assets/imgs/icon-assest1.png'),
					name: this.i18n.t('assest.tab1'),
          type: 5,
					count: 0,
				},
				{
          url: require('../../assets/imgs/icon-assest2.png'),
					name: this.i18n.t('assest.tab2'),
          type: 1,
					count: 0,
				},
				{
          url: require('../../assets/imgs/icon-assest3.png'),
					name: this.i18n.t('assest.tab3'),
          type: 2,
					count: 0
				},
				{
          url: require('../../assets/imgs/icon-assest4.png'),
					name: this.i18n.t('assest.tab4'),
          type: 3,
					count: 0
				},
				{
          url: require('../../assets/imgs/icon-assest5.png'),
					name: this.i18n.t('assest.tab5'),
          type: 4,
					count: 0
				},
				{
          url: require('../../assets/imgs/icon-assest6.png'),
					name: this.i18n.t('assest.tab6'),
          type: 6,
					count: 0
				},
			]
    }
  },
  mounted() {
    this.init()
    this.initAssets()
    this.initValuationPrices()
  },
  methods: {
    formatAsset24hRate,
    asset24hRateClass,
    initAssets() {
      myAssets({
        Unit: this.bitName
      }).then(res => {
        let data = res.data
        this.userMoney = this.resetMoney(data.Total)
        this.use = this.resetMoney(data.Capital)
        this.accountList[0].count = this.resetMoney(data.Capital)
        this.accountList[1].count = this.resetMoney(data.Option)
        this.accountList[2].count = this.resetMoney(data.Contract)
        this.accountList[3].count = this.resetMoney(data.Spot)
        this.accountList[4].count = this.resetMoney(data.Finance)
        this.accountList[5].count = this.resetMoney(data.Finance) // 跟单

        this.ProfitAndLoss = parseFloat(data.ProfitAndLoss).toFixed(2)
        this.Asset24hChangeRate = data.Asset24hChangeRate || '0.00'
      })
    },
    initValuationPrices() {
      Promise.all([
        allTrades({}),
        getCoinList({
          current: 1,
          pageSize: 500,
          Status: 1,
        })
      ]).then(([tradeRes, coinRes]) => {
        const tradeRows = tradeRes.data || []
        const coinRows = coinRes.data && coinRes.data.Items ? coinRes.data.Items : []
        this.valuationPriceMap = buildAssetValuationPriceMap(tradeRows, coinRows)
      }).catch(() => {
        this.valuationPriceMap = {}
      })
    },
    getBitMoney(money) {
      return getAssetValuationDisplay(money, this.valuationCurrency, this.valuationPriceMap) || '--'
    },
    resetMoney(val) {
      return parseFloat(val).toFixed(4)
    },
    init() {
      
      userInfo().then(res => {
        setAssets(res.data.Assets)
      })

      checkAuth().then(res => {
        this.realNameStatus = res.data.status
      })
    },
    changeMoneyType() {
      this.showMoney = !this.showMoney
    },
    changeBit() {
      this.showBitPage = true
    },
    openValuationPopup() {
      this.showValuationPopup = true
    },
    chooseValuationCurrency(currency) {
      if (this.valuationOptions.indexOf(currency) == -1) {
        return
      }
      this.valuationCurrency = currency
      this.showValuationPopup = false
      localStorage.setItem('assetValuationCurrency', currency)
      if (!this.valuationPriceMap[currency]) {
        this.initValuationPrices()
      }
    },
    cancel() {
      this.showBitPage = false
      this.showRecharge = false
      this.showModal = false
    },
    toPath(path, query) {
      if (path) {
        this.$router.push({
          name: path,
          query
        })
      }
    },
    toWithdraw() {
      if (this.realNameStatus == '2') {
        this.toPath('withdraw')
      } else if (this.realNameStatus == '1') {
        this.$toast.fail(this.i18n.t('assest.label7'))
      } else {
        this.toPath('userAuth')
      }
    },
    changeRecharge(data, i) {
      this.rechargeIndex = i
      this.rechargeName = data.name
    },
    toRechargePage() {
      if (this.rechargeName == 'Bank') {
        this.$router.push({
          name: 'kefu'
        })
      } else {
        this.$router.push({
          path: '/recharge?type=' + this.rechargeName
        })
      }
    },
    toAccount(data, i) {
      if (i == 0) {
        return
      }
      this.$router.push({
        path: '/account',
        query: {
          type: data.type,
        }
      })
    },
    changeAuth(i) {
      this.authIndex = i
    },
    toAuth() {
      this.$router.push({
        name: 'userAuth',
        query: {
          type: this.authIndex
        }
      })
    },
  }
}
</script>
